import api from "./api";

export const listBlockedContacts = async (params = {}) => {
  const { data } = await api.get("/blocked-contacts", { params });
  return data;
};

export const unblockBlockedContact = async (id) => {
  const { data } = await api.put(`/blocked-contacts/${id}/unblock`);
  return data;
};
